import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@mesh.ai/rabbit';
import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { staticRoutes } from 'Deer/constants/routes';
import { PageNotFound404 } from 'Deer/pages/PageNotFound404';
import AdminOrManagerRoute from 'components/AdminOrManagerRoute';
import { useQuery } from 'components/hooks/useQuery';
// Ensure this hook is implemented correctly
import { Route, Switch, useHistory } from 'react-router-dom';
import Competencies from 'screens/admin/Competencies';
import { CompetencySettings } from 'screens/admin/Competencies/CompetencySettings/CompetencySettings';

import { PLATFORM_ADMIN } from 'constants/ProjectConstants';
import { sendClickedOnPreferencesTabEvent } from 'constants/mixpanelHelpers/genericEvents';

export const MODULE_SETTINGS_TABS = [
  {
    name: 'Competency Library',
    queryParamId: 'competency_library',
    Comp: Competencies,
  },
  {
    name: 'Competency Settings',
    queryParamId: 'competency_settings',
    Comp: CompetencySettings,
  },
];

const CompetenciesSettingsTab = () => {
  const history = useHistory();
  const { activeTabId } = useQuery();

  const onTabChangeHandler = (newActiveTab: string) => {
    sendClickedOnPreferencesTabEvent({
      eventProperties: {
        activeTabId,
      },
    });
    history.push({
      search: `?${new URLSearchParams({
        activeTabId: newActiveTab,
      }).toString()}`,
    });
  };

  useEffect(() => {
    if (!activeTabId) {
      onTabChangeHandler(MODULE_SETTINGS_TABS[0].queryParamId);
    }
  }, [activeTabId]);

  return (
    <>
      <Box p={4}>
        <PlainTextHeader>My company&apos;s competencies</PlainTextHeader>
      </Box>

      <Tabs variant="secondary" value={activeTabId as string} onValueChange={onTabChangeHandler} className="mt-1">
        <TabsList>
          {MODULE_SETTINGS_TABS.map(({ name, queryParamId }) => (
            <TabsTrigger key={queryParamId} value={queryParamId}>
              {name}
            </TabsTrigger>
          ))}
        </TabsList>

        {MODULE_SETTINGS_TABS.map(({ Comp, queryParamId }) => (
          <TabsContent key={queryParamId} value={queryParamId}>
            <Comp />
          </TabsContent>
        ))}
      </Tabs>
    </>
  );
};

const CompetenciesSettings = () => (
  <Switch>
    <AdminOrManagerRoute
      exact
      path={staticRoutes.company.settings.competencies}
      component={CompetenciesSettingsTab}
      redirectionPath={staticRoutes.home}
      roles={[PLATFORM_ADMIN]}
    />
    <Route path="*" component={PageNotFound404} />
  </Switch>
);

export default CompetenciesSettings;
